import React from 'react';
import { Link } from 'react-router';
import { header } from 'constants/table';
import DataTable from 'components/data-table';
import { CheckPermission } from 'modules/login/CheckPermission';
import { RowItemDanhSachCuocThanhTraPage } from 'modules/thanh-tra/datatable';
import { API_URL } from 'constants/config';
import { Search } from './sub-view';
import { ThanhTra } from 'api';
import moment from 'moment';
import {Toastr} from 'modules/toastr';
import { isEmpty } from 'lodash';
import { ShowIf } from 'components/utils';
import { downloadExcel } from 'constants/downloadExcel';

class DanhSachCuocThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      advanceSearch: false,
      search: false,
      showDropdownCreate: false,
    }
  }

  componentDidMount() {
    this.getDataList();
  }

  checkDate(stD, endD) {
    let startDate = moment(stD, 'MM/DD/YYYY').valueOf();
    let endDate = moment(endD, 'MM/DD/YYYY').valueOf();
    if (startDate > endDate) {
      Toastr('Từ ngày phải nhỏ hơn Đến ngày', 'warning');
    }
  }

  toggleDropdownCreate() {
    this.setState({
      ...this.state,
      showDropdownCreate: !this.state.showDropdownCreate
    })
  }

  getDataList() {
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size
    }

    if (this.state.tenDoiTuongThanhTra) {
      params.tenDoiTuongThanhTra = this.state.tenDoiTuongThanhTra;
    }

    if (this.state.phanLoai) {
      params.phanLoai = this.state.phanLoai;
    }

    if (this.state.soQuyetDinh) {
      params.soQuyetDinh = this.state.soQuyetDinh;
    }

    if (this.state.loaiHinhThanhTra) {
      params.loaiKeHoach = this.state.loaiHinhThanhTra;
    }

    if (this.state.linhVucThanhTra) {
      params.linhVucThanhTra = this.state.linhVucThanhTra;
    }

    if (this.state.quyetDinhPheDuyetKHTT) {
      params.quyetDinhPheDuyetKHTT = this.state.quyetDinhPheDuyetKHTT;
    }

    if (this.state.tienDoThanhTra) {
      params.tienDoThanhTra = this.state.tienDoThanhTra;
    }

    if (this.state.tuNgay) {
      params.tuNgay = moment(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }

    if (this.state.denNgay) {
      params.denNgay = moment(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }

    if (this.state.tuNgay && this.state.denNgay) {
      this.checkDate(this.state.tuNgay, this.state.denNgay);
    }

    if (this.state.soKetLuanThanhTra) {
      params.soKetLuanThanhTra = this.state.soKetLuanThanhTra;
    }

    if (this.state.soQuyetDinhXL) {
      params.soQuyetDinhXL = this.state.soQuyetDinhXL;
    }

    if (!isEmpty(this.state.namThanhTra)) {
      params.namThanhTra = this.state.namThanhTra;
    }
    ThanhTra.actions.getCuocThanhTra.request(null, params).then(res => {
     if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.cuocThanhTras,
          pageData: res.data.page,
          tableLoading: false,
          search: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false,
          search: false
        });
      }
    });
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getDataList();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getDataList();
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  componentWillUnmount() {

  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  openSearchForm() {
    this.setState({
      advanceSearch: true
    });
  }

  closeSearchForm() {
    this.setState({
      advanceSearch: false
    });

  }

  handleDelete(sID) {
    ThanhTra.actions.deleteCuocThanhTra.request({id: sID}).then(res => {
      Toastr('Xóa cuộc thanh tra thành công', 'success');
      this.getDataList();
    });
  }

  handleSearch(data) {
    if(this.validateSubmitForm()) {
      this.state = {
        ...this.state,
        ...data,
        search: true
      }
      this.setState({...this.state});
      this.getDataList();
    }
  }

  exportExcel() {
    const name = 'danh-muc-cuoc-thanh-tra-kiem-tra';
    const apiUrl = 'cuocThanhTras/export-excel'
    // eslint-disable-next-line no-useless-concat
    const URL = `${String(API_URL)}/${apiUrl}` + "?soQuyetDinh=" + this.state.soQuyetDinh
    + "&tuNgay=" + (this.state.tuNgay ? moment(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '')
    + "&denNgay=" + (this.state.denNgay ? moment(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '')
    + "&namThanhTra=" + (this.state.namThanhTra ? this.state.namThanhTra : '')
    + "&tenDoiTuongThanhTra=" + (this.state.tenDoiTuongThanhTra ? this.state.tenDoiTuongThanhTra : '')
    + "&phanLoai=" + (this.state.phanLoai ? this.state.phanLoai : '')
    + "&loaiKeHoach=" + (this.state.loaiHinhThanhTra ? this.state.loaiHinhThanhTra : '')
    + "&tienDoThanhTra=" + (this.state.tienDoThanhTra ? this.state.tienDoThanhTra : '')
    + "&soKetLuanThanhTra=" + (this.state.soKetLuanThanhTra ? this.state.soKetLuanThanhTra : '')
    + "&soQuyetDinhXL=" + (this.state.soQuyetDinhXL ? this.state.soQuyetDinhXL : '');
    downloadExcel(URL, name, true);
  }

  render() {
    return (
      <div className="center reception-container">
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-thanh-tra"></i>Danh mục cuộc thanh tra, kiểm tra</p>
          </div>
          <div className="right-content dropdown-create-wrap">
            <ShowIf condition={CheckPermission('THANHTRA_THEM')}>
              <Link className="btn-green btn-dropdown" onClick={this.toggleDropdownCreate.bind(this)}><i className="tt tt-addfile"></i>Thêm mới cuộc đột xuất</Link>
              {
                this.state.showDropdownCreate && (
                  <div className='dropdown-create'>
                    <Link className="dropdown-item" to='/thanh-tra/them-moi-cuoc-thanh-tra'>Cuộc thanh tra đột xuất</Link>
                    <Link className="dropdown-item" to='/thanh-tra/them-moi-cuoc-kiem-tra'>Cuộc kiểm tra đột xuất</Link>
                  </div>
                )
              }
            </ShowIf>
          </div>
        </div>
        <div className="bottom-content thanh-tra-search">
          <div className={ this.state.advanceSearch ? 'search-container super-search' : 'search-container show-label' }>
            <Search ref="listSearch" advanceSearch={this.state.advanceSearch} bindValidator={this} onCancel={ this.closeSearchForm.bind(this) } handleSearch={ this.handleSearch.bind(this) } disabled={ this.state.searching } search={ this.state.search }/>
            <Link className="rearch-text" onClick={ this.openSearchForm.bind(this) }><i className="tt tt-super-search"></i>Tìm kiếm nâng cao</Link>
          </div>
          <DataTable
            header={header.thanhTra.DSCTT}
            dataList={this.state.data}
            thanhTra={true}
            hideButtonExport={false}
            pageData={this.state.pageData}
            exporttext="Xuất báo cáo"
            handleExport={this.exportExcel.bind(this)}
            parent={this}
            search={this.state.search}
            tableLoading={this.state.tableLoading}>
            <RowItemDanhSachCuocThanhTraPage getList={this.getDataList.bind(this)}/>
          </DataTable>
        </div>
      </div>
    );
  }
}

DanhSachCuocThanhTra.defaultProps = {
  validators: {
    formTaoDon: []
  }
}

export default DanhSachCuocThanhTra;



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/DanhSachCuocThanhTra.jsx